import React from "react";
import { ReactComponent as Linkedin } from "../../../../assets/icons/socialIcons/linkedinIcon.svg";
import { ReactComponent as Twitter } from "../../../../assets/icons/socialIcons/TWITTER.svg";
import { ReactComponent as Instagram } from "../../../../assets/icons/socialIcons/instagramicon.svg";
import { ReactComponent as Facebook } from "../../../../assets/icons/socialIcons/FACEBOOK.svg";
import { ReactComponent as Global } from "../../../../assets/icons/socialIcons/GlobeIcon.svg";
import { ReactComponent as Share } from "../../../../assets/icons/socialIcons/ShareIcon.svg";
import { SocialIcons } from "../../../common";

const CompanySocialIcons = ({ company, checkURL, setIsShareModalOpen, setShareURL }) => {
  const socialLinks = [
    { key: 'linkedin', icon: <Linkedin className="sm:h-auto h-7" /> },
    { key: 'twitter', icon: <Twitter className="sm:h-auto h-7" /> },
    { key: 'instagram', icon: <Instagram className="sm:h-auto h-7" /> },
    { key: 'facebook', icon: <Facebook className="sm:h-auto h-7" /> },
    { key: 'website', icon: <Global className="sm:h-auto h-7" /> },
  ];

  return (
    <div className="flex gap-0 sm:gap-2 justify-start sm:justify-end">
      {socialLinks.map(({ key, icon }) => (
        company?.[key] && (
          <SocialIcons
            key={key}
            link={checkURL(company[key])}
            classes="sm:w-auto w-1/2"
            targetdata="_blank"
          >
            {icon}
          </SocialIcons>
        )
      ))}

      <SocialIcons classes="sm:w-auto w-1/2">
        <Share
          onClick={() => {
            setIsShareModalOpen(true);
            setShareURL(window.location.href);
          }}
          className="sm:h-auto h-7"
        />
      </SocialIcons>
    </div>
  );
};

export default CompanySocialIcons;
